import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DashboardPopup from '../DashboardPopup'
import Button from 'components/UI/Button/Button'
import SelectInput from 'components/UI/FormInput/Select'
import {
  StyledForm,
  StyledFormInput,
  ButtonRow,
  StyledButton
} from './CreateNewClassPopup.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class CreateNewClassPopup extends Component {
  constructor (props) {
    super(props)

    this.state = {
      age: null
    }
  }

  render () {
    return (
      <DashboardPopup
        onCancel={this.props.onCancel}
        isSettings
      >
        <StyledForm id='password-popup' onValidSubmit={this.props.onConfirm}>
          <StyledFormInput
            fieldName={'New Class Name'}
            fieldNameColor={colors.pink}
            placeholderColor={colors.grey}
            focusColor={colors.orange}
            backgroundFocusColor={colors.lightOrange}
            element={'button'}
            narrow
            width='80%'
            textSize='15px'
            fieldNameSize='18px'
            onChange={this.onInputChange}
            name='groupName'
            placeholder='Enter a class name'
            required
          />
          <SelectInput
            fieldName={'Age'}
            onChange={(val) => {
              this.setState({
                age: val.value
              })
              this.onInputChange
            }}
            value={this.state.age}
            options={[
              { label: 'up to 7', value: 1 },
              { label: '7-8', value: 2 },
              { label: '8-9', value: 3 },
              { label: '9-10', value: 4 },
              { label: '10-11', value: 5 },
              { label: '11 and above', value: 6 }
            ]}
            required
            fieldNameColor={colors.pink}
            name='yearGroup'
            wrapperStyle={{
              width: '100%',
              margin: 'auto'
            }}
          />
          <StyledFormInput
            displayStyle='inline'
            className='StudentNumber'
            fieldName={'Number of students'}
            fieldNameColor={colors.pink}
            placeholderColor={colors.grey}
            focusColor={colors.orange}
            backgroundFocusColor={colors.lightOrange}
            element={'button'}
            narrow
            width='80%'
            textSize='15px'
            fieldNameSize='18px'
            onChange={this.onInputChange}
            type={'number'}
            name='nbStudents'
            placeholder='0'
            required
          />
        </StyledForm>
        <ButtonRow>
          <Button
            element='button'
            type='submit'
            form='password-popup'
            bgColor={colors.grassGreen}
            color='white'
            size='regular'
          >
            Create
          </Button>
          <Button
            bgColor={colors.red}
            color='white'
            size='regular'
            onClick={this.props.onCancel}
          >
            Cancel
          </Button>
        </ButtonRow>
      </DashboardPopup>
    )
  }
}
